const loader = (state = false, action) => {
    switch (action.type) {
        case "SHOW_ERROR":
            return action.data;
        case "HIDE_ERROR":
            return action.data;
        default:
            return state;
    }
}

export default loader;